import(/* webpackMode: "eager" */ "/vercel/path0/src/app/remove-pages/page.tsx");
